import { isSupported } from 'firebase/messaging';
import { createContext, useEffect, useMemo, useReducer } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { _showStates } from '../../../App';
import { papsHandlers, papsInitialState, papsReducer } from '../reducers/PapsReducer';
import { useRenders } from './useHelpers/useRenders';
import { currentHelpers } from 'global/redirection/current';

const showStatus = false

/** 
 * @parentContexts [StartContext, AuthContext, AppSettingContext] 
 * @provides paps_state, paps_handlers
 * @description Contains information about the current page location (url, path, etc.) 
 * */
export const PapsContext = createContext();

/** 
 * @parentContexts [StartContext, AuthContext, AppSettingContext] 
 * @provides paps_state, paps_handlers
 * @description Contains information about the current page location (url, path, etc.) 
 * */
const PapsProvider = (props) => {

  const { pathname: newPathName, search } = useLocation()

  const _params = useMemo(
    () => Object.fromEntries(new URLSearchParams(search)),
    [search]
  )

  const [paps_state, paps_dispatch] = useReducer(papsReducer, papsInitialState());
  const { settingsDocName, pathname: paps_pathName } = paps_state

  const paps_handlers = useMemo(
    () => papsHandlers(paps_dispatch),
    [paps_dispatch]
  );

  useRenders('PapsProvider', true, null)

  useEffect(() => {
    isSupported().then(messagingSupported => {
      paps_handlers.handleUpdate_messagingSupported(messagingSupported)
    })
    const current = currentHelpers.getCurrent(newPathName, paps_pathName, _params)
    paps_handlers.handleAmmend_current(current, paps_pathName, _params)
    // eslint-disable-next-line
  }, [newPathName, search]);



  const providerContext = () => <PapsContext.Provider value={{ paps_state: { ...paps_state, showStatus }, paps_handlers: { ...paps_handlers }, pathName: newPathName }}>
    {props.children}
  </PapsContext.Provider>
  // return <div className='cntr' style={{ color: 'white' }}>{settingsDocName}</div> 
  // return providerContext()
  return settingsDocName ? providerContext() : <div></div>
}

export default PapsProvider